export default __webpack_public_path__ + "static/media/folyamatabraUres.b507b0e9.jpg";